import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Button, Form, Row, Col, Badge, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DANGKY_DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    doiTuongValue,
    objectDoiTuong,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT,
    objectShowNumber
} from '../../../../../utils/define';
import DangKyHoSoModal from '../hoSoTuyenSinh/DangKyHoSoModal';

const DangKyDotTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DANGKY_DOTTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['dotTuyenSinhDangKyData', valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DANGKY_DOTTUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const [showModal, setShowModal] = useState(false);
    const [selectedDotTuyenSinh, setSelectedDotTuyenSinh] = useState(null);

    const handleRegister = (id) => {
        setSelectedDotTuyenSinh(id);
        setShowModal(true);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    return (
        <Container fluid className="py-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="font-weight-bold" style={{ color: '#2c3e50' }}>Danh sách Đợt Tuyển Sinh</h3>
            </div>

            {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Đang tải...</span>
                    </div>
                </div>
            ) : isError ? (
                <div className="alert alert-danger text-center">
                    Lỗi: {error?.message || 'Không tải được dữ liệu'}
                </div>
            ) : items.length === 0 ? (
                <div className="alert alert-info text-center py-5">
                    Hiện tại không có đợt tuyển sinh nào đang mở.
                </div>
            ) : (
                <>
                    <Row>
                        {items.map((item, index) => {
                            const doiTuongLabel = getLabelFromEnum(item.doiTuong ?? item.DoiTuong, objectDoiTuong, doiTuongValue);
                            const loaiTSLabel = getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue);
                            const trangThaiLabel = getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue);
                            
                            const valDoiTuong = item.doiTuong ?? item.DoiTuong;
                            const actualDoiTuong = typeof valDoiTuong === 'string' ? doiTuongValue[valDoiTuong] : valDoiTuong;
                            const quan = item.chiTieuQuan ?? item.ChiTieuQuan ?? 0;
                            const dan = item.chiTieuDan ?? item.ChiTieuDan ?? 0;
                            
                            let chiTieuStr = '0';
                            if (actualDoiTuong === doiTuongValue.quan) chiTieuStr = `${quan}`;
                            else if (actualDoiTuong === doiTuongValue.khac) chiTieuStr = `${dan}`;
                            else if (actualDoiTuong === doiTuongValue.quanVaDan) chiTieuStr = `Quân: ${quan} | Dân: ${dan}`;

                            const fee = new Intl.NumberFormat('vi-VN').format(item.lePhi ?? item.LePhi ?? 0);
                            
                            const tStart = (item.ngayNhanHoSo || item.NgayNhanHoSo) ? moment(item.ngayNhanHoSo || item.NgayNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';
                            const tEnd = (item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo) ? moment(item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';

                            return (
                                <Col lg={4} md={6} sm={12} className="mb-4" key={item.id || index}>
                                    <Card className="h-100 shadow-sm border-0" style={{ transition: 'transform 0.2s', borderRadius: '12px', overflow: 'hidden' }}
                                          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                                        <div style={{ height: '6px', backgroundColor: '#007bff' }}></div>
                                        <Card.Body className="d-flex flex-column">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <Badge variant="primary" className="mb-2 px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}>Năm: {item.namTuyenSinh || item.NamTuyenSinh}</Badge>
                                                <Badge variant={trangThaiLabel === 'Mở' ? 'success' : 'secondary'} className="px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}>
                                                    {trangThaiLabel}
                                                </Badge>
                                            </div>
                                            <Card.Title className="font-weight-bold" style={{ fontSize: '1.2rem', color: '#34495e', lineHeight: '1.4' }}>
                                                {item.tenDot || item.TenDot}
                                            </Card.Title>
                                            
                                            <div className="mt-3 flex-grow-1" style={{ fontSize: '14px', color: '#555' }}>
                                                <div className="mb-2"><i className="fas fa-graduation-cap text-primary mr-2" style={{ width: '16px' }}></i> <strong>Loại TS:</strong> {loaiTSLabel}</div>
                                                <div className="mb-2"><i className="fas fa-users text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng:</strong> {doiTuongLabel}</div>
                                                <div className="mb-2"><i className="fas fa-chart-bar text-primary mr-2" style={{ width: '16px' }}></i> <strong>Chỉ tiêu:</strong> {chiTieuStr}</div>
                                                <div className="mb-2"><i className="fas fa-money-bill-wave text-primary mr-2" style={{ width: '16px' }}></i> <strong>Lệ phí:</strong> <span className="text-danger font-weight-bold">{fee} VNĐ</span></div>
                                                <div className="mb-2">
                                                    <i className="far fa-calendar-alt text-primary mr-2" style={{ width: '16px' }}></i> 
                                                    <strong>Thời gian nhận hồ sơ:</strong>
                                                    <div className="ml-4 mt-1 text-muted" style={{ fontSize: '13px' }}>{tStart} - {tEnd}</div>
                                                </div>
                                            </div>

                                            <div className="mt-4 pt-3 border-top text-center">
                                                <Button variant="primary" block className="font-weight-bold rounded-pill shadow-sm" onClick={() => handleRegister(item.id)} style={{ padding: '10px 20px', fontSize: '15px' }}>
                                                    <i className="fas fa-edit mr-2"></i> Đăng ký ngay
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                    
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                </>
            )}

            <DangKyHoSoModal 
                show={showModal} 
                handleClose={() => setShowModal(false)} 
                dotTuyenSinhId={selectedDotTuyenSinh}
            />
        </Container>
    );
};

export default DangKyDotTuyenSinh;
